import React from 'react';

import PropTypes from 'prop-types';
import styled, { keyframes } from 'styled-components';

const Wrapper = styled.div`
  height: ${(props) => props.$height};
  width: ${(props) => props.$width};
`;

const spin = keyframes`
  0% { transform: rotate(0deg); }
  100% { transform: rotate(359deg); }
`;

const RotatingOutline = styled('use')`
  transform-origin: center;
  animation: ${spin} 3s infinite cubic-bezier(0.785, 0.135, 0.15, 0.86);
`;

export default function LoadingIndicator({
  baseFill = '#fff',
  logoFill = '#231F20',
  rotatingOutlineFill = '#000',
  size = '100px',
}) {
  return (
    <Wrapper $width={size}>
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 74 74">
        <defs>
          <circle id="a" cx="37" cy="37" r="37" />
          <mask id="b" width="74" height="74" x="0" y="0" fill={baseFill}>
            <use xlinkHref="#a" />
          </mask>
          <path id="c" d="M0 29.172V.403h32.67v28.77z" />
        </defs>
        <g fill="none" fillRule="evenodd">
          <RotatingOutline
            stroke={rotatingOutlineFill}
            strokeDasharray="4,4"
            strokeLinejoin="bevel"
            strokeWidth="2"
            mask="url(#b)"
            xlinkHref="#a"
          />
          <g transform="translate(22 23)">
            <mask id="d" fill={baseFill}>
              <use xlinkHref="#c" />
            </mask>
            <path
              fill={logoFill}
              d="M32.32 2.085c-.304.959-.863 2.2-1.874 3.21 0 0-1.267 1.773-4.336 3.01 0 0-1.95.837-5.387 1.144 0 0-2.92.312-7.32.24a74.077 74.077 0 0 0-.993-.023c-4.362-.04-6.147.69-6.147.69-2.13.73-3.507 2.961-4.331 4.908l-.001.003c-.033.078-1.06 2.52-1.925 6.972-.001.01-.003.02-.006.029v-10.06c.018-.5.043-1.039.077-1.538a9.748 9.748 0 0 1 4.918-7.376c.55-.37 3.117-1.436 7.21-1.47 1.24-.01 8.152-.077 11.247-.18 7.17-.237 9.218-1.24 9.218-1.24-.156 1.128-.35 1.681-.35 1.681M21.75 17.401c-4.186 1.762-11.806 1.535-13.232 1.807-1.417.268-4.894-.107-7.385 5.068a2.914 2.914 0 0 1 2.248-1.063c1.624 0 2.94 1.333 2.94 2.98 0 1.644-1.316 2.98-2.94 2.98a2.934 2.934 0 0 1-2.673-1.75l-.01-.02a2.447 2.447 0 0 1-.17-.511 3.42 3.42 0 0 1-.085-.69v-.015c-.002-.103-.013-.2-.006-.312.022-.361.064-.742.118-1.128v-.031c.005-.032.011-.06.018-.093.333-2.264 1.1-4.648 1.1-4.648l.009.017c.395-1.36.647-1.895.665-1.936v-.002c.826-1.948 2.204-4.183 4.335-4.91 0 0 1.788-.734 6.15-.693h.022a29.559 29.559 0 0 1 .974.023c4.405.072 7.326-.24 7.326-.24 3.44-.306 5.51-.946 7.21-2.047-.353 1.366-1.743 5.164-6.615 7.214"
              mask="url(#d)"
            />
          </g>
        </g>
      </svg>
    </Wrapper>
  );
}

LoadingIndicator.propTypes = {
  baseFill: PropTypes.string,
  logoFill: PropTypes.string,
  rotatingOutlineFill: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
};
